import { IBaseTag, IProjectTag } from './client';
import { ProjectTagServer, UserTagServer } from './server';

export const normalizeUserTag = (raw: UserTagServer): IBaseTag => ({
  id: raw._id,
  name: raw.name
});

export const normalizeProjectTag = (raw: ProjectTagServer): IProjectTag => ({
  id: raw._id,
  name: raw.name,
  usersCount: raw.users_count,
  dateCreated: new Date(raw.date_created),
  dateUpdated: new Date(raw.date_updated)
});

export const normalizeUserTagToListItem = (
  raw: UserTagServer
): { entity: IBaseTag; key: string } => ({
  entity: normalizeUserTag(raw),
  key: raw._id
});
